import apiUrl from "../../../constants";
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate'
import VueAlertify from 'vue-alertify';
import {BasicSelect} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper'
import { getCountfun } from '../../../common/validations.js'
import pendingGroupIdShipments from '../common/pendingShipmentsforDelivery'
import HanoverShipmentList from '../common/HanoverShipmentList'
import moment from 'moment'
import svcInScanPending from '../common/svcInScanPending.vue'
import shortageShipments from '../common/shortageShipments.vue'
import Paginate from 'vuejs-paginate'
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";
import dummyInput from '../common/smartInput.vue'

export default {
  name: 'agenthandover',
  components: {
  BasicSelect, VueElementLoading, Paginate,
  'pending-shipments' : pendingGroupIdShipments,
  'handover-shipment': HanoverShipmentList,
  'svcInScan-Pending':svcInScanPending,
  'shortage-Shipments': shortageShipments,
  'dummy-input': dummyInput
  },
  props: [],
  mixins:[PageTracker],
  data () {
    return {
      agentname:'',
      agentitem:{id:'',text:'',phone:''},
      Agent:'',
      AgentId:'',
      AgentPhone:'',
      handovermode:'',
      vehicleno:'',
      handoverpersonname:'',
      ShippingId:'',
      awbArray1:[],
      obj:{},
      superagentsarray:[],
      showTable: false,
      returnArray:[],
      input:{
          "EntityType": "Agent"
      },
      shipmentDetails:[],
      isHandoverLoader: false,
      changePage:'1',
      process:'',
      awb:'',
      awbArray2:[],
      obj:{},
      buttonLabel: 'InScan',
      isInScanReturnLoader: false,
      JobType: '',
      ActiveTabIndex: 0,
      isPendingShipmentforDeliveryLoader: false,
      pendingShipmentForDeliveryobj:[],
      pageNo: 1,
      totalPendingShipmentforDeliverycnt: 0,
      pageCount: 1,
      HandoverpageCount: 1,
      shipmentKeySearchById: '',
      isHandoverShipmentListLoader: false,
      HandoverShipmentList: [],
      totalHandoverShipmentcnt: 0,
      JobType1: '',
      takeInputShippingIdByuser: true,
      closeTripModel: false,
      suggestRVPArrayList: [],
      morePendingRVPShipmentsModel: false,
      isLoadingASL: false,
      sAllMoreShip: [],
      selectedReverseChildShipmentData: [],
      AllocatePageNo: 1,
      allocatePageSize: 20,
      selectedRVPShipmentForHandover: [],
      totalPendingShipments:0,
      shipmentList: [],
      isLoadingList: false,
      isLoadingModel:false,
      svcPendingSearchById: '',
      searchSvcPendingShipment: '',
      showPaginate:false,
      showPaginateModeldl:false,
      pagecount: 1,
      pageCountModel:1,
      returnInScanBTabs:0,
      svcInScanPendingBTabs:0,
      pendingForReturnBTabs:0,
      mdlSVCInScanPendingBTabs:0,
      mdlPendingForReturnBTabs:0,
      primaryType:'SVCInscanPending',
      shipmentType:'Forward',
      mdlSVCInScanPending:false,
      mdlPendingForReturn:false,
      showPaginateModel:false,
      pendingForReturnSearchById:'',
      shippingIdSvcInScanPendingMdl:'',
      shippingIdPendingForReturnMdl:'',
      pageNumber:1,
      pageNumberModel:1,
      shipmentListModel:[],
      totalPendingShipmentsModel:'',
      primaryTypeModel:'SVCInscanPending',
      shipmentTypeModel:'Forward',
      isCourierId:true,
      isRemoveOption: false,
      pincodes:{},
      isRVPFeataureEnableForTesting: false,
      hubSpecificRVPAllowed: [1695,3085,614,277,93,1442,405,191,195,190,91,228,1785,2744,516,615,2046],
      userDataKey : '',
      isShowDummyInput: false,
      styleData: {},
      dummyInputTimeout: 20000,
    }
  },
  computed: {

  },
  watch: {
    ShippingId: createClearInputWatcher('ShippingId'),
    awb: createClearInputWatcher('awb'),
  },
  async mounted() {
      //this.getSuperAgents();
      this.userDataKey = window.localStorage.getItem('userUniqueKey');
      let validateUser = await this.validateJwtToken();
      var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      //console.log(userdetail);
      this.userid = userdetail.userid
      this.createdBy = userdetail.userid
      this.hubdetails = userdetail.hubdetails[0];
      this.userfullname = userdetail.username;
      this.mobilenumber = userdetail.mobilenumber;
      let checkhub = this.hubSpecificRVPAllowed.find( value => value == this.hubdetails );

      if(process.env.NODE_ENV == 'production' && checkhub != undefined){
        this.isRVPFeataureEnableForTesting = true;
      } else if(process.env.NODE_ENV == 'development'){
        this.isRVPFeataureEnableForTesting = true;
      }
      this.getSuperAgents(this.hubdetails);

      const vm = this;
      // if(this.changePage == '1'){
      //   $("#ShippingId").keydown(function (event) {
      //     var keycode = (event.keyCode ? event.keyCode : event.which);
      //     if (keycode == 13) {
      //       vm.validateForm1('form-1');
      //       return false;
      //       event.stopPropagation();
      //     }
      //   });
      // }
  },
  watch: {
    ActiveTabIndex(ActiveTabIndex){
      this.shipmentKeySearchById = '';
    }
  },
  methods: {
    KeycheckFunction(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == 13) {
        if(this.changePage == '1'){
          //console.log('form-1');
          this.validateForm1('form-1');
          return false;
          event.stopPropagation();
        } else {
          //console.log('form-2');
          this.validateForm2('form-2');
          return false;
          event.stopPropagation();
        }
      }
    },
    getPaginationShipmentListData(pageNo){
      this.pageNumber = pageNo;
      this.getPendingShipmentsData(this.primaryType,this.shipmentType)
    },
    removeHandoverShipment(shippingId){
      let reqPayload = {
        "shippingId": shippingId,
        "LastModifiedBy": this.userfullname,
        "hubid": this.hubdetails,
        "shipmentType": this.JobType
      }
      try{
        this.isHandoverShipmentListLoader = true;
        axios({
          method:'POST',
          url: apiUrl.api_url + 'AgentHandoverReturn/RemoveHandoverShipments',
          data: reqPayload
        }).then(result =>{
          if (result.data.code === 200) {
            this.$alertify.success(result.data.message);
            this.TransferredShipmentToAgentList();
          } else {
            this.$alertify.error(result.data.message);
          }
          this.isHandoverShipmentListLoader = false;
        })
      } catch(e){
        this.isHandoverShipmentListLoader = false;
        console.log('Error',e);
      }
      //console.log('reqPayload',reqPayload);
    },
    switchTabs(primaryType,shipmentType){
      if (this.$refs.paginateRefs1.selected > 0) {
        this.$refs.paginateRefs1.selected = 0;
      }
      if (this.$refs.paginateRefs2.selected > 0) {
        this.$refs.paginateRefs2.selected = 0
      }
      this.pageNumber = 1;
      this.shipmentType = shipmentType;
      this.primaryType = primaryType
      if (this.svcPendingSearchById) {
        this.svcPendingSearchById = ''
        document.getElementById('Shipping_Id').value = '';
      }
      if (this.pendingForReturnSearchById) {
        this.pendingForReturnSearchById = ''
        document.getElementById('Shippingid').value = '';
      }
      if (primaryType === 'SVCInscanPending' && shipmentType === 'Forward') {
        this.svcInScanPendingBTabs = 0;
      }else if (primaryType === 'SAReturnPending' && shipmentType === 'Forward') {
        this.pendingForReturnBTabs = 0;
      }

      this.getPendingShipmentsData(primaryType,shipmentType);
      return false
    },
    getPendingShipmentsData(primaryType,shipmentType,shippingid){
      this.isLoadingList = true;

      if (this.shipmentList.length > 0) {
        this.shipmentList = [];
      }
      if (this.pagecount > 0) {
        this.pagecount = 0;
      }
      if (this.totalPendingShipments !== '' || this.totalPendingShipments) {
        this.totalPendingShipments = '';
      }
      if (this.showPaginate === true) {
        this.showPaginate = false;
      }else {
        this.showPaginate = true;
      }
      let inputPayload = {
        "HubID":this.hubdetails,
        "ShipmentStatus":primaryType,
        "PageNo":this.pageNumber,
        "PageSize":20,
        "ShipmentType":shipmentType
      }
      if (this.svcPendingSearchById) {
        inputPayload.ShippingID = this.svcPendingSearchById.trim();
        this.showPaginate = false;
      }else if (this.pendingForReturnSearchById) {
        inputPayload.ShippingID = this.pendingForReturnSearchById.trim();
        this.showPaginate = false;
      }else {
        this.showPaginate = true;
      }
      this.customAPIURL = apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub';
      axios({
        method:'POST',
        url: this.customAPIURL,
        data: inputPayload
      }).then(result =>{
        if (result.data.code === 200) {
          this.shipmentList = result.data.result.Shipments
          this.totalPendingShipments = result.data.result.TotalShipments;
          if (this.totalPendingShipments < 20) {
            this.pagecount = 1
          }else {
            this.pagecount = Math.ceil(this.totalPendingShipments / 20)
          }
        }else {
          this.shipmentList = [];
        }
        this.isLoadingList = false;
      }).catch(err =>{
        console.log("Error Details", err);
        return false;
      })
    },
    reloadReturnInScanTab(primaryType){
      if (primaryType === 'SVCInscanPending' || primaryType === 'SAReturnPending') {
        if (this.svcPendingSearchById !== '') {
          this.svcPendingSearchById = '';
          document.getElementById('Shipping_Id').value = '';
        }
        if (this.pendingForReturnSearchById) {
          this.pendingForReturnSearchById = ''
          document.getElementById('Shippingid').value = '';
        }
        this.getPendingShipmentsData(primaryType,this.shipmentType);
      }
      if (primaryType === 'SVC'){
        if (this.shippingIdSvcInScanPendingMdl) {
          this.shippingIdSvcInScanPendingMdl = '';
          document.getElementById('ShippingIdSvcInScanPendingMdl').value = '';
        }
        this.getPendingShipmentsDataModel('SVCInscanPending',this.shipmentTypeModel)
      }
      if(primaryType === 'SARP') {
        if (this.shippingIdPendingForReturnMdl) {
          this.shippingIdPendingForReturnMdl = '';
          document.getElementById('ShippingIdPendingForReturnMdl').value = '';
        }
        this.getPendingShipmentsDataModel('SAReturnPending','Reverse')
      }
    },
    openModal(primaryType){
      if (primaryType === 'SVCInscanPending') {
        this.mdlSVCInScanPending = true;
        if (this.mdlSVCInScanPendingBTabs > 0) {
          this.mdlSVCInScanPendingBTabs = 0;
        }
        this.getPendingShipmentsDataModel(primaryType,'Forward')
      }else {
        this.mdlPendingForReturn = true;
        this.getPendingShipmentsDataModel(primaryType,'Reverse')
      }
    },
    closeModal(type){
      this.pageNumberModel = 1;
      if (this.$refs.paginateRefsMdl1.selected > 0) {
        this.$refs.paginateRefsMdl1.selected = 0;
      }
      if (this.$refs.paginateRefsMdl2.selected > 0) {
        this.$refs.paginateRefsMdl2.selected = 0;
      }
      if (this.mdlSVCInScanPending) {
        this.mdlSVCInScanPending = false;
      }else {
        this.mdlPendingForReturn = false;
      }
      if (this.shippingIdSvcInScanPendingMdl) {
        this.shippingIdSvcInScanPendingMdl = '';
        document.getElementById('ShippingIdSvcInScanPendingMdl').value = '';
      }
      if (this.shippingIdPendingForReturnMdl) {
        this.shippingIdPendingForReturnMdl = '';
        document.getElementById('ShippingIdPendingForReturnMdl').value = '';
      }

    },
    switchTabsModel(primaryType,shipmentType){
      this.shipmentTypeModel = shipmentType;
      if (this.$refs.paginateRefsMdl1.selected > 0) {
        this.$refs.paginateRefsMdl1.selected = 0;
      }
      if (this.$refs.paginateRefsMdl2.selected > 0) {
        this.$refs.paginateRefsMdl2.selected = 0
      }
      this.pageNumberModel = 1;
      this.primaryTypeModel = primaryType
      this.shipmentTypeModel = shipmentType;

      if (this.shippingIdSvcInScanPendingMdl) {
        this.shippingIdSvcInScanPendingMdl = ''
        document.getElementById('ShippingIdSvcInScanPendingMdl').value = '';
      }
      if (this.shippingIdPendingForReturnMdl) {
        this.shippingIdPendingForReturnMdl = ''
        document.getElementById('ShippingIdPendingForReturnMdl').value = '';
      }
      if (primaryType === 'SVCInscanPending' && shipmentType === 'Forward') {
        this.mdlSVCInScanPendingBTabs = 0;
      }
      // else if (primaryType === 'SAReturnPending' && shipmentType === 'Forward') {
      //   this.mdlPendingForReturnBTabs = 0;
      // }

      this.getPendingShipmentsDataModel(primaryType,shipmentType);
      return false
    },
    getPendingShipmentsDataModel(primaryType,shipmentType){
      this.isLoadingModel = true;
      if (this.shipmentListModel.length > 0) {
        this.shipmentListModel = [];
      }
      if (this.pageCountModel > 0) {
        this.pageCountModel = 0;
      }
      if (this.totalPendingShipmentsModel !== '' || this.totalPendingShipmentsModel) {
        this.totalPendingShipmentsModel = '';
      }

      if (this.showPaginateModel === true) {
        this.showPaginateModel = false;
      }else {
        this.showPaginateModel = true;
      }
      let inputPayloadModel = {
        "HubID":this.hubdetails,
        "ShipmentStatus":primaryType,
        "PageNo":this.pageNumberModel,
        "PageSize":20,
        "ShipmentType":shipmentType
      }
      if (this.shippingIdSvcInScanPendingMdl) {
        inputPayloadModel.ShippingID = this.shippingIdSvcInScanPendingMdl.trim();
        this.showPaginateModel = false;
      }else if (this.shippingIdPendingForReturnMdl) {
        inputPayloadModel.ShippingID = this.shippingIdPendingForReturnMdl.trim();
        this.showPaginateModel = false;
      }else {
        this.showPaginateModel = true;
      }
      axios({
        method:"POST",
        url: apiUrl.api_url + 'rvpinscanshipment/getsareturnpendingagainsthub',
        data:inputPayloadModel
      }).then( result =>{
        this.isLoadingModel = false;
        if (result.data.code === 200) {
          this.shipmentListModel = result.data.result.Shipments
          this.totalPendingShipmentsModel = result.data.result.TotalShipments;
          if (this.totalPendingShipmentsModel < 20) {
            this.pageCountModel = 1
          }else {
            this.pageCountModel = Math.ceil(this.totalPendingShipmentsModel / 20)
          }
        }else {
          this.shipmentListModel = [];
        }
      }).catch( err => {
        this.isLoadingModel = false;
        console.log("Error Details", err);
        return false;
      })
    },
    getPaginationShipmentListDataMdl(pageNo){
      this.pageNumberModel = pageNo;
      this.getPendingShipmentsDataModel(this.primaryType,this.shipmentTypeModel)
    },
    getPaginationData(pageNum){
      this.pageNo =  pageNum;
      this.loadPendingShipments();
      //console.log('event triggred success');
    },
    getHandoverPaginationData(pageNum){
      this.AllocatePageNo = pageNum;
      this.TransferredShipmentToAgentList();
    },
    getSelectedShipments(selectShipments){
      this.selectedRVPShipmentForHandover = selectShipments
    },
    searchAllPendingShipments(){
      if(this.ActiveTabIndex == 0){
          if(event.keyCode === 13) {
            if(this.JobType == 'RVP'){
              var searchvalue = this.shipmentKeySearchById.toLowerCase();
              let cnt = 1;
              $("#shipmentListRvp tbody tr").filter(function() {
                $(this).toggle($(this).text().toLowerCase().indexOf(searchvalue) > -1)
              });
              //let rowCount = $('#shipmentListRvp >tbody >tr').length;
              let rowCount = $('#shipmentListRvp > tbody >tr').filter(function() {
                  return $(this).css('display') !== 'none';
              }).length;
              this.totalPendingShipmentforDeliverycnt = parseFloat(rowCount) / 2;
            } else {
              this.loadPendingShipments();
            }
          }
      } else {
        if(event.keyCode === 13) {
          this.AllocatePageNo = 1;
          this.TransferredShipmentToAgentList();
        }
      }
    },
    searchAllPendingShipmentsonButtonEvent(){
      if(this.JobType == 'RVP'){
        var searchvalue = this.shipmentKeySearchById.toLowerCase();
        $("#shipmentListRvp tbody tr").filter(function() {
          $(this).toggle($(this).text().toLowerCase().indexOf(searchvalue) > -1)
        });
        let rowCount = $('#shipmentListRvp > tbody >tr').filter(function() {
            return $(this).css('display') !== 'none';
        }).length;
        this.totalPendingShipmentforDeliverycnt = parseFloat(rowCount) / 2;

      } else {
        this.loadPendingShipments();
      }
    },
    reloadPendingShipmentList(){
      this.pageNo = 1;
      this.shipmentKeySearchById = '';

      //console.log('this.parent.$refs',this.trackPaginate.$refs.paginate);
      //this.trackPaginate.$refs.paginate.selected= 0;
      this.loadPendingShipments();
      this.TransferredShipmentToAgentList();
    },
    changeJobTypeEvent(){
      //console.log('changed event');
      if(this.JobType == 'RVP'){
        this.isRemoveOption = true;
      } else {
        this.isRemoveOption = false;
      }
      this.pageNo = 1
      this.loadPendingShipments();
      this.TransferredShipmentToAgentList();
    },
    viewFullScreenModel(){
      this.closeTripModel = true;
    },
    closeCloseTripModel(){
      this.closeTripModel = false;
    },
    loadPendingShipments(reload=false){
      this.pendingShipmentForDeliveryobj = [];
      this.selectedRVPShipmentForHandover = [];
      //this.$refs.PendingShipments.selectedReverseShipmentData = [];
      this.selectedRVPShipmentForHandover = [];
      let jobtypeOveride = this.JobType == 'Delivery' ? 'Forward' : this.JobType;
      this.JobType1 = jobtypeOveride;
      let customApiUrl = '';
      let listofPincodes = '';
      if(jobtypeOveride == 'RVP') {
        this.input = {
          "hubid": this.hubdetails,
          "shipmenttype":'Reverse',
          "status": 'Pending'
        }
        if (this.AgentId) {
          listofPincodes = this.pincodes.RVP.toString()
          this.input.Pincode = listofPincodes;
        }
        customApiUrl = apiUrl.api_url + 'expose/shipment/reversepending/list'
      } else {
        this.input = {
          "HubID": this.hubdetails.toString(),
          "ShipmentType":jobtypeOveride,
          "PageNo":this.pageNo
        }
        if (this.AgentId) {
          if (jobtypeOveride === 'RTO') {
            listofPincodes = this.pincodes.RTO.toString();
          }else if (jobtypeOveride === 'DTO') {
            listofPincodes = this.pincodes.DTO.toString();
          }else if(jobtypeOveride === 'Delivery' || jobtypeOveride === 'Forward'){
            listofPincodes = this.pincodes.Delivery.toString();
          }
          // else {
          //   console.log("pincode",this.pincodes);
          //   $.each(this.pincodes, (key, value) => {
          //     value.forEach((item, index) =>{
          //       listofPincodes = listofPincodes + item + ',';
          //     })
          //   })
          // }
        }
        if (listofPincodes) {
          // let slicedValue = listofPincodes.substring(0, listofPincodes.length - 1);
          // this.input.Pincode = slicedValue;
          this.input.Pincode = listofPincodes;
        }

        customApiUrl = apiUrl.api_url + 'expose/get/pending/shipment/details'
        if(reload == true){
          this.shipmentKeySearchById = "";
        }
        if(this.shipmentKeySearchById !="") {
          this.input["ShippingId"] = this.shipmentKeySearchById.trim()
        }
      }

      this.isPendingShipmentforDeliveryLoader = true;

      axios({
        method: 'POST',
        url: customApiUrl,
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.pendingShipmentForDeliveryobj = result.data.data
          //console.log('pendingShipmentForDeliveryobj', this.pendingShipmentForDeliveryobj);
          if(this.JobType == 'RVP'){
            this.totalPendingShipmentforDeliverycnt = this.pendingShipmentForDeliveryobj.length;
          } else {
            this.totalPendingShipmentforDeliverycnt = result.data.Total
            if (this.totalPendingShipmentforDeliverycnt < 20) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalPendingShipmentforDeliverycnt / 20);
            }
          }

        } else{
          this.pageCount = 1;
          this.pendingShipmentForDeliveryobj = [];
          this.totalPendingShipmentforDeliverycnt = 0;

        }
        this.isPendingShipmentforDeliveryLoader = false
      }, error => {
        this.isPendingShipmentforDeliveryLoader = false
        console.error(error)
      })
    },
    TransferredShipmentToAgentList(reload=false){
      if(this.Agent != ''){
        //let jobtypeOveride = this.JobType == 'Delivery' ? 'Forward' : this.JobType;
        let reqPayload = {
            "ShipmentType": this.JobType,
            "HubId": this.hubdetails,
            "OutSourcingMasterId": this.AgentId,
            "pageNo": this.AllocatePageNo,
            "pageSize": this.allocatePageSize
        }
        if(this.JobType == 'RVP'){
          reqPayload["isHandover"] = '1'
        }
        //console.log('reload',reload);
        if(reload == true){
          this.shipmentKeySearchById = '';
          reqPayload["pageNo"] = 1;
        }
        if(this.shipmentKeySearchById !="") {
          reqPayload["ShippingId"] = this.shipmentKeySearchById.trim()
          reqPayload["pageNo"] = 1;
        }
        this.isHandoverShipmentListLoader = true;
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'pending/shipments/byHubID',
          data: reqPayload
        })
        .then(result => {
          if (result.data.code==200) {
            this.HandoverShipmentList = result.data.data
            this.totalHandoverShipmentcnt = result.data.totalcount;
            if (this.totalHandoverShipmentcnt < this.allocatePageSize) {
              this.HandoverpageCount = 1
            } else {
              this.HandoverpageCount = Math.ceil(this.totalHandoverShipmentcnt / this.allocatePageSize);
            }
          } else{
            this.HandoverpageCount = 1;
            this.totalHandoverShipmentcnt = 0;
            this.HandoverShipmentList = [];
          }
          this.isHandoverShipmentListLoader = false
        }, error => {
          this.isHandoverShipmentListLoader = false
          console.error(error)
        })
      }
    },
    selectAllMoreRVPShipments(ev){
      this.selectedReverseChildShipmentData = [];
      if (ev.target.checked == true) {
        $.each(this.suggestRVPArrayList, (key,value) => {
          this.selectedReverseChildShipmentData.push(value.ShippingId);
        })
      }else {
        this.selectedReverseChildShipmentData = [];
      }
    },
    checkPendingForRVP() {
      this.selectedPickupsMore=[]
    },
    closeRvpSuggestShipmentsModel(){
      this.morePendingRVPShipmentsModel = false
    },
    getPendingForRVPList() {
      this.errorRvpAllocation = "";
      this.successRvpAllocation = '';
      this.awbArray1 = this.selectedRVPShipmentForHandover;
      return new Promise( (resolve, reject) => {
        this.suggestRVPArrayList = []
        var relShippingIds = []
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/rvp/shipments',
          data: {ShippingID:this.awbArray1}
        })
        .then(response => {
          var resultData = response.data
          if(resultData.code == 200 && typeof resultData.data !== 'undefined') {
            var result = resultData.data;
            //console.log('result child Pending',resultData.data);
            for (var i = 0; i < result.length; i++) {
              if(result[i].ReversePickUpData.length>0) {
                let tempData = result[i].ReversePickUpData
                for (var j = 0; j < tempData.length; j++) {
                  relShippingIds.push(tempData[j])
                }
              }
            }
            if(relShippingIds.length>0) {
              for (var i = 0; i < relShippingIds.length; i++) {
                for (var j = 0; j < this.awbArray1.length; j++) {
                  if(relShippingIds[i]==this.awbArray1[j]) {
                    relShippingIds.splice(i,1);
                  }
                }
              }
              var uniqueArray = []
              for (var i = 0; i < relShippingIds.length; i++) {
                if(uniqueArray.indexOf(relShippingIds[i]) === -1) {
                  uniqueArray.push(relShippingIds[i]);
                }
              }
              // console.log(uniqueArray.length);
              // console.log('awbArray1 array',this.awbArray1.length);
              var suggestRVPArrayList=[]
              for (var i = 0; i < this.pendingShipmentForDeliveryobj.length; i++) {
                if(uniqueArray.includes(this.pendingShipmentForDeliveryobj[i].ShippingId)) {
                  this.suggestRVPArrayList.push(this.pendingShipmentForDeliveryobj[i]);
                }
              }
              // console.log('this.suggestRVPArrayList',this.suggestRVPArrayList);
              resolve({success:true});
            }
          } else {
            resolve({success:false});
          }
        }, error => {
          resolve({success:false});
        })
      });
    },
    validateForm1(scope) {
      this.$validator.validateAll(scope).then(result => {
        let validateStatus = true;
        console.log('this.$refs.PendingShipments.selectedReverseShipmentData.',this.selectedRVPShipmentForHandover);
        if(this.JobType == 'RVP') {
          if(this.selectedRVPShipmentForHandover.length == 0 ){
            this.$alertify.error('Please select atleast one shipment from Available for transfer list.!');
            validateStatus = false;
          }else if(this.selectedRVPShipmentForHandover.length > 100) {
            this.$alertify.error('Please select only maximum 100 Shipping ids.!');
            validateStatus = false;
          }
        }
        if (result && validateStatus) {
          this.isHandoverLoader = true;
          if(this.JobType == 'RVP'){
            this.handovermode=''
            this.vehicleno=''
            this.handoverpersonname=''
            this.ShippingId=''
            //rvp shipments handover process
            this.getPendingForRVPList().then( (result) => {
              if(result.success) {
                this.morePendingRVPShipmentsModel = true
                this.isHandoverLoader = false
              } else {
                this.awbArray1 = this.selectedRVPShipmentForHandover;
                // console.log('this.awbArray1',this.awbArray1);
                this.handoverShipmentsToAgent(this.awbArray1);
              }
            });

          } else {
            //non rvp shipments handover logic start here.
            let shippingidsWithNextLine = this.ShippingId.split("\n").map(String);
            let shippingidsWithComma = this.ShippingId.split(",").map(String);
            if(shippingidsWithNextLine.length > 1) {

              $.each(shippingidsWithNextLine, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            } else if(shippingidsWithComma.length >= 1){

              $.each(shippingidsWithComma, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            }
            this.handoverShipmentsToAgent(this.awbArray1);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
        this.isHandoverLoader = false;
      });
    },
    rvpHandoverShipment(){
      let mergeRvpShipmentData = [];
      $.each(this.awbArray1, (key,value) => {
        mergeRvpShipmentData.push(value);
      })
      console.log('this.awbArray1',this.awbArray1);
      if(this.selectedReverseChildShipmentData.length > 0){
        $.each(this.selectedReverseChildShipmentData, (key, value) => {
          mergeRvpShipmentData.push(value);
        })
        console.log('mergeRvpShipmentData',mergeRvpShipmentData);
      }
      this.isHandoverLoader = true;
      this.morePendingRVPShipmentsModel = false;
      this.handoverShipmentsToAgent(mergeRvpShipmentData)
    },
   async handoverShipmentsToAgent(shipmentList){
      this.isShowDummyInput = false;
      let setLocusFlag = await this.checkIsLocusEnableforhub()

        let userProcessCode = 'XBU00280';
        if(this.JobType == 'RTO'){
          userProcessCode = 'XBU00560';
        } else if(this.JobType == 'Delivery' || this.JobType == 'DTO'){
          userProcessCode = 'XBU00280';
        } else if(this.JobType == 'RVP'){
          userProcessCode = 'XBU00573'
        }

        let obj = {
          couriercompanyid:this.AgentId,
          couriercompanyname:this.Agent,
          couriercompanyphone:this.AgentPhone,
          awb:shipmentList,
          hubid:this.hubdetails.toString(),
          userfullname:this.userfullname,
          userProcessCode: userProcessCode,
          isroutingenable: setLocusFlag
        }

        if(this.JobType != '') {
          obj.jobType = this.JobType
          if(obj.jobType != 'RVP' ){
            obj.handovermode = this.handovermode
            obj.vehicleno = this.vehicleno
            obj.handoverpersonname = this.handoverpersonname
          } else {
            obj.handovermode = "",
            obj.vehicleno = "",
            obj.handoverpersonname = ""
          }
        }
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'AgentHandover/Handover',
              'data': obj,
              header:{
                'content-type': 'application/json'
              }
            }).then(result => {
              this.showTable = true;
              this.returnArray = result.data.data;
              this.isShowDummyInput = true;
              this.styleData = result.data.lossCategorization;

              if(result.data.code === 200){
                //this.$alertify.success(result.data.message);
                // tracking api integration start here
                let TrackerInfo = {
                    projectname:"Last Mile",
                    type:"Web",
                    userid:this.userid,
                    username:this.userfullname,
                    meta: {
                        "event":"agenthandover",
                        "shippingId": this.awbArray1.toString(),
                        "couriercompanyname": this.Agent +' - '+ this.AgentId
                    }
                }
                this.PageTracker(TrackerInfo);
                //end
              }else {
                this.$alertify.error(result.data.message);
              }
              this.reloadPendingShipmentList();
              this.selectedRVPShipmentForHandover = [];
              this.selectedReverseChildShipmentData = [];
              this.suggestRVPArrayList = [];
              this.isHandoverLoader = false;
              this.ShippingId='';
              this.$validator.reset();
              this.errors.clear();
              this.awbArray1 = [];
          })
        .catch((httpException) => {
            this.$alertify.error("Something went wrong!!");
            console.error('exception is:::::::::', httpException)
            this.isHandoverLoader = false;
            this.ShippingId='';
            this.$validator.reset();
            this.errors.clear();
            this.awbArray1 = [];
            this.selectedReverseChildShipmentData = [];
            this.morePendingRVPShipmentsModel = false;
        })
      .catch((httpException) => {
          this.$alertify.error("Something went wrong!!");
          console.error('exception is:::::::::', httpException)
          this.isHandoverLoader = false;
      });
    },
    SelectAgent(agentitem){
      this.agentitem=agentitem
      this.Agent=this.agentitem.text
      this.AgentId=this.agentitem.id
      this.AgentPhone=this.agentitem.phone
      this.handovermode=''
      this.vehicleno=''
      this.handoverpersonname=''
      this.ShippingId=''
      this.awbArray1=[]
      this.obj={}
      this.showTable= false
      this.returnArray=[],
      this.JobType = '',
      this.isRemoveOption = false;
      this.$validator.reset();
      this.errors.clear();
      this.isHandoverLoader = false;
      this.getPincodesAgainstAgentId();
    },
    getPincodesAgainstAgentId(){

      axios({
        method:'GET',
        url: apiUrl.api_url + 'agenthandover/getpincodes/againstcouriercompanyid?couriercompanyid=' + this.AgentId,
      }).then(result =>{
        this.pincodes = result.data.data.servicablePincodes;
        this.loadPendingShipments();
        this.TransferredShipmentToAgentList();
      }).catch(err =>{
        console.log("Error Details", err);
        return false;
      })
    },
    getSuperAgents(hubId){
      // axios.get(apiUrl.api_url + 'AgentHandover/getAgentList', {})
      let inputPayload = {
        "EntityType": 'Agent',
        "HubID": hubId
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'AgentHandover/getAgentList',
          'data': inputPayload,
          header:{
            'content-type': 'application/json'
          }
        })
        .then((result) => {
            this.AgentDetails = result.data.data;
            for (var i = 0; i < this.AgentDetails.length; i++) {
              this.superagentsarray.push({
                "id": this.AgentDetails[i].id,
                "text": this.AgentDetails[i].name,
                "phone": this.AgentDetails[i].ContactPersonMobileNo
              })
            }
        })
        .catch((httpException) => {
            this.$alertify.error("Super Agent data not found");
            console.error('exception is:::::::::', httpException)
        })
    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addAgentHandover();
          console.log('submittedd');
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    resetForm1(){
      this.agent=''
      this.agentname=''
      this.handovermode=''
      this.vehicleno=''
      this.handoverpersonname=''
      this.ShippingId=''
      this.awbArray1=[]
      this.obj={}
      this.showTable= false
      this.returnArray=[],
      this.agentitem = {},
      this.JobType = '',
      this.$validator.reset();
      this.errors.clear();
      this.isHandoverLoader = false;
      this.isShowDummyInput = false;
      this.$refs.dummyShipInputBox.clearStyles();
      this.loadPendingShipments()
    },
    ChangeLabelName(){
      this.buttonLabel = this.process == 'Shortage' ? 'Mark Shortage' : 'InScan';
    },
    validateForm2(scope) {
      this.isShowDummyInput = false;
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.isInScanReturnLoader = true;
          let shippingidsWithNextLine = this.awb.split("\n").map(String);
          let shippingidsWithComma = this.awb.split(",").map(String);
          if(shippingidsWithNextLine.length > 1) {

            $.each(shippingidsWithNextLine, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray2.push(sid.trim());
              }
            })
          } else if(shippingidsWithComma.length >= 1){

            $.each(shippingidsWithComma, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray2.push(sid.trim());
              }
            })
          }

          let obj = {
            userfullname:this.userfullname,
            userphno:this.mobilenumber,
            process:this.process,
            awb:this.awbArray2,
            createdby:'Agent'
          }
          //console.log("obj",obj);
          axios({
              method: 'POST',
              'url':  apiUrl.api_url + 'AgentInscanReturn/InscanReturn',
              'data': obj,
              header:{
                'content-type': 'application/json'
              }
          }).then(result => {
            this.showTable = true;
            this.returnArray = result.data.data;
            this.isShowDummyInput = true;
            this.styleData = result.data.lossCategorization;
            
            if(result.data.code === 200){
              //tracker api called here
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.userid,
                username:this.userfullname,
                meta: {
                    "event":"inscanreturntosvc",
                    "process" : this.process,
                    "shipment": this.awbArray2.toString()
                }
              }
              this.PageTracker(TrackerInfo);
              //end
                //this.$alertify.success(result.data.message);
            } else {
              if(typeof result.data.details !== 'undefined') {
                this.$alertify.error(result.data.details[0].message);
              } else{
                this.$alertify.error(result.data.message);
              }
            }
            this.awb = '';
            this.awbArray2 = [];
            this.$validator.reset();
            this.errors.clear();
            this.isInScanReturnLoader = false;
            this.reloadReturnInScanTab(this.primaryType)
          })
          .catch((httpException) => {
              this.$alertify.error("Something went wrong!!");
              console.error('exception is:::::::::', httpException)
              this.isInScanReturnLoader = false;
          });
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
        this.isInScanReturnLoader = false;
      });
    },
    resetForm2(){
      this.agent=''
      this.agentname=''
      this.handovermode=''
      this.vehicleno=''
      this.handoverpersonname=''
      this.awb=''
      this.process = ''
      this.awbArray2=[]
      this.obj={}
      this.showTable= false
      this.returnArray=[]
      this.$validator.reset();
      this.errors.clear();
      this.isInScanReturnLoader = false;
      this.isShowDummyInput = false;
      this.$refs.dummyShipInputBox.clearStyles();
    },
    clearAllFields(){
      this.resetForm1();
      this.resetForm2();
      if(this.changePage == 1){
        this.loadPendingShipments();
      } else {
        this.returnInScanBTabs = 0;
        if (this.svcInScanPendingBTabs !== 0) {
        this.svcInScanPendingBTabs = 0;
        }
        this.getPendingShipmentsData('SVCInscanPending','Forward');
      }
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  }
}

Validator.extend('VerifyShippingidFormatforAdmin1', {
  getMessage: field => "maximum 100 Shipping ids you can enter",
  validate: async value => {
      var shippingids = $("#ShippingId").val();
      let cnt = await getCountfun(shippingids);
      return cnt;
  }
});
Validator.extend('VerifyShippingidFormatforAdmin2', {
  getMessage: field => "maximum 100 Shipping ids you can enter",
  validate: async value => {
      var shippingids = $("#awb").val();
      let cnt = await getCountfun(shippingids);
      return cnt;
  }
});



// WEBPACK FOOTER //
// ./src/views/components/agenthandover/agenthandover.component.js